import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "36",
  width: "50",
  viewBox: "0 0 50 36",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M44.333 36H5.667C2.5 36 0 33.5 0 30.333V5.667C0 2.5 2.5 0 5.667 0h38.666C47.5 0 50 2.5 50 5.667v24.75C50 33.5 47.5 36 44.333 36z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3961aa"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#eb1829",
    d: "M41.916 18.083a9.667 9.667 0 0 1-9.666 9.667 9.667 9.667 0 0 1-9.667-9.667 9.667 9.667 0 0 1 9.667-9.666 9.667 9.667 0 0 1 9.666 9.666z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#0093d9",
    d: "M27.5 18.083a9.667 9.667 0 0 1-9.667 9.667 9.667 9.667 0 0 1-9.666-9.667 9.667 9.667 0 0 1 9.666-9.666 9.667 9.667 0 0 1 9.667 9.666z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M16.333 16.083H33.75v4H16.333z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  })]
});